import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment-timezone'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import PhoneNumber from './PhoneNumber'
import Email from './Email'
import Name from './Name';

const ContactInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()

  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [phoneNumberValid, setPhoneNumberValid] = useState('')
  const [emailValid, setEmailValid] = useState('')

  const [phoneNumberError, setPhoneNumberError] = useState('contact_info.phone_number_error')
  const [emailError, setEmailError] = useState('contact_info.email_error')

  const [nameValid, setNameValid] = useState('')
  const [nameError, setNameError] = useState('jointly_owned_vehicle_info.name_error')
  const { phoneNumber, email, name } = useSelector((state) => state.app.contactInformation)

  const { houseHoldMembers } = useSelector((state) => state.app.personalInformation)
  // useEffect(() => {
  //   try {
  //     if (!nsHealthCard && !driverLicence && !vehiclePermit && !registeredByName) {
  //       history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])

  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get("isSummary") ?? false);
  }, [history]);

  const onNext = () => {
    try {
      if (validateFields()) {
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      validatePhoneNumber(phoneNumber)
      validateEmail(email)
      validateName(name);
      if (phoneNumber === '') {
        setPhoneNumberValid(false)
      }
      if (email === '') {
        setEmailValid(false)
      }
      const isNameRequired = houseHoldMembers.length !== 1
      if (isNameRequired && name === '') {
        setNameValid(false);
      }
      return (
        phoneNumberValid === true &&
        emailValid === true &&
        (isNameRequired ? nameValid === true : true) &&
        phoneNumber !== '' &&
        email !== ''
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePhoneNumber = (number) => {
    try {
      if (number.length > 0) {
        if (number.length === 12) {
          setPhoneNumberValid(true)
        } else {
          setPhoneNumberValid(false)
          setPhoneNumberError('contact_info.phone_number_error_invalid')
        }
      } else {
        setPhoneNumberValid(false)
        setPhoneNumberError('contact_info.phone_number_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateEmail = (number) => {
    try {
      // eslint-disable-next-line
      const regex = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      if (number.length > 0) {
        if (regex.test(number)) {
          setEmailValid(true)
        } else {
          setEmailValid(false)
          setEmailError('contact_info.email_address_error_invalid')
        }
      } else {
        setEmailValid(false)
        setEmailError('contact_info.email_address_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }


  const validateName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ& ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          setNameValid(true)
        } else {
          setNameValid(false)
          setNameError('jointly_owned_vehicle_info.name_error_invalid')
        }
      } else {
        setNameValid(false)
        setNameError('jointly_owned_vehicle_info.name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12 col-lg-12">
              <h1>{t('contact_info.title')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {houseHoldMembers.length !== 1 && (
                <Name
                  validateName={validateName}
                  nameError={nameError}
                  nameValid={nameValid}
                  setIsError={setIsError}
                />
              )}

              <PhoneNumber
                validatePhoneNumber={validatePhoneNumber}
                phoneNumberError={phoneNumberError}
                phoneNumberValid={phoneNumberValid}
                setIsError={setIsError}
              />
              <Email
                validateEmail={validateEmail}
                emailError={emailError}
                emailValid={emailValid}
                setIsError={setIsError}
              />
            </div>
          </div>
          <ContinueCancelButtons continueClick={onNext} errorText={''} />
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(ContactInformationView)
